import React from 'react';

const RoleSelection = ({ onSelectRole }) => {
  return (
    <div className="su-role-selection" style={{ animation: 'su-fade-in-up 0.3s ease-out forwards' }}>
      <div className="su-card-header">
        <h2>Who are <span>you?</span></h2>
        <div className="su-card-underline" />
        <p>Choose your account type to get started</p>
      </div>

      <div className="su-role-cards">
        <div className="su-big-role-card" onClick={() => onSelectRole('candidate')}>
          <div className="su-role-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
            </svg>
          </div>
          <h3>Candidate</h3>
          <p>I want to find the perfect job and grow my career</p>
        </div>

        <div className="su-big-role-card" onClick={() => onSelectRole('employer')}>
          <div className="su-role-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
            </svg>
          </div>
          <h3>Employer</h3>
          <p>I want to hire top talent and build my team</p>
        </div>
      </div>
    </div>
  );
};

export default RoleSelection;
